module.exports = __webpack_public_path__ + "static/media/news-spectrum-national-suicide-prevention-month.1966b57d.jpg";